<template>
    <div class="item_sidebar product_list_settings">
        <div class="title title_m_b">{{title}}:</div>

        <div class="list_item_block mb_20" v-for="(item, index) in value" :key="index">
            <div class="aic_juscb_edit">
                <div class="title">Title:</div>
                <a @click="removeItem(index)" class="delete_btn btn brdr_btn">
                    <img :src="require('@/assets/page/img/delete_icon.svg')"/>
                </a>
            </div>
            <div class="wrapper_input mb_20">
                <input type="text" placeholder="Product title" class="w_100" :value="item.title" @change="updatedData($event.target.value, 'title', index)">
            </div>
            <div class="title title_m_b">Price:</div>
            <div class="wrapper_input">
                <input type="text" placeholder="Product title" class="w_100" :value="item.price" @change="updatedData($event.target.value, 'price', index)">
            </div>
        </div>
        <a @click="addNewItem" class="btn">Add new item</a>
    </div>
</template>

<script>

export default {
    name: 'ProductListSettings',
    components: {
    },
    props: ["value", "title"],
    data: function(){
        return {
            listItemsData: {}
        }
    },
    methods: {
        updatedData(val, fieldName, index){
            if(val) {
                this.listItemsData[index][fieldName] = val;
            }

            this.$emit('updated', this.listItemsData);
        },
        addNewItem(){
            let newItem = { title: ('New item '+ (this.listItemsData.length + 1)), pcs: 1, price: '100.00' };
            this.listItemsData.push(newItem);

            this.updatedData();
        },
        removeItem(index){
            if (index > -1) {
                this.listItemsData.splice(index, 1);
            }

            this.$emit('updated', this.listItemsData);
        },
    },
    created() {
        this.listItemsData = JSON.parse(JSON.stringify(this.value));
        this.updatedData();
    }
}
</script>